export default __webpack_public_path__ + "static/media/emotion-m.fd42d73f.png";